import { useEffect, useState } from "react"
import "./Policy.css"
import { useNavigate } from "react-router-dom"
import { Info } from "react-bootstrap-icons"

export const Policy = () => {

    const [show, setShow] = useState()
    const agreePolicy = () => {
        localStorage.setItem("agreePolicy", true)
    }

    const navigete = useNavigate()
    const toNav = (link) => {
        window.scrollTo(0, 0)
        navigete(link)
    }

    useEffect(() => {
        const status = localStorage.getItem("agreePolicy")
        if (status !== "true") {
            setTimeout(() => {
                setShow('is-widget-open')
            }, 1000)
        }
    }, [])

    const close = () => {
        setShow(null)
        agreePolicy()
    }

    return (
        <>
            <div className={`${show} policy-widget`}>
                {/* <button className="widget__close" onClick={() => { close() }}>
                    <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="12.25" height="12.312" viewBox="0 0 12.25 12.312">
                        <path fill="currentColor" d="M499.364,781.3l0.455-.454,11.817,11.816-0.455.455Zm0.455,11.772-0.455-.455L511.181,780.8l0.455,0.454Z" transform="translate(-499.375 -780.813)"></path>
                    </svg>
                </button> */}
                <div className="policy-wrapper">
                    <div className="policy-widget-container">
                        <div className="widget__item">
                            {/* <div className="policy-image">
                                <Info size={40} />
                            </div> */}
                            <div className="policy-text">
                                Шоу-пространство Ленинград Центр защищает персональные данные пользователей и обрабатывает Cookies только для персонализации сервисов.
                                Запретить обработку Cookies можно в настройках Вашего браузера. Пожалуйста, ознакомьтесь с <a style={{ cursor: 'pointer' }} onClick={() => { toNav("/documents") }}><u>Условиями обработки персональных данных</u></a>, <a style={{ cursor: 'pointer' }} onClick={() => { toNav("/documents") }}><u>Правила применения рекомендательных технологий</u></a> и <a style={{ cursor: 'pointer' }} onClick={() => { toNav("/cookiespolicy") }}><u>Cookies</u></a>.
                                <div className="mt-2 me-auto text-end">
                                    <button className="btn btn-lc btn-lc-rounded" onClick={() => { close() }}>Принять</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* } */}
        </>
    )
}